var _rect, _rect2, _rect3, _path, _path2, _rect4, _path3, _path4, _path5, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntroImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 170,
    viewBox: "0 0 241 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 63,
    width: 216,
    height: 44,
    rx: 22,
    fill: "#E4EDFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 62,
    width: 46,
    height: 46,
    rx: 23,
    fill: "#F6B40A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 62,
    width: 46,
    height: 46,
    rx: 23,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5 73C30.5 79.6274 25.1274 85 18.5 85C25.1274 85 30.5 90.3726 30.5 97C30.5 90.3726 35.8726 85 42.5 85C35.8726 85 30.5 79.6274 30.5 73Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.5 115C219.069 115 232.5 101.569 232.5 85C232.5 68.4315 219.069 55 202.5 55C185.931 55 172.5 68.4315 172.5 85C172.5 101.569 185.931 115 202.5 115ZM202.5 110.385C216.52 110.385 227.885 99.0195 227.885 85C227.885 70.9805 216.52 59.6154 202.5 59.6154C188.48 59.6154 177.115 70.9805 177.115 85C177.115 99.0195 188.48 110.385 202.5 110.385Z",
    fill: "#0C5EFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 180.5,
    y: 63,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#0C5EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M202.5 75C196.98 75 192.5 79.48 192.5 85C192.5 90.52 196.98 95 202.5 95C208.02 95 212.5 90.52 212.5 85C212.5 79.48 208.02 75 202.5 75ZM199.15 87.77C199.04 88.07 198.75 88.26 198.45 88.26C198.36 88.26 198.28 88.25 198.19 88.21C197.38 87.91 196.7 87.32 196.27 86.55C195.27 84.75 195.89 82.4 197.64 81.31L199.98 79.86C200.84 79.33 201.85 79.17 202.81 79.42C203.77 79.67 204.58 80.3 205.07 81.18C206.07 82.98 205.45 85.33 203.7 86.42L203.44 86.61C203.1 86.85 202.63 86.77 202.39 86.44C202.15 86.1 202.23 85.63 202.56 85.39L202.87 85.17C203.99 84.47 204.37 83.02 203.76 81.91C203.47 81.39 203 81.02 202.44 80.87C201.88 80.72 201.29 80.81 200.78 81.13L198.42 82.59C197.34 83.26 196.96 84.71 197.57 85.83C197.82 86.28 198.22 86.63 198.7 86.81C199.09 86.95 199.29 87.38 199.15 87.77ZM207.42 88.65L205.08 90.1C204.49 90.47 203.83 90.65 203.16 90.65C202.86 90.65 202.55 90.61 202.25 90.53C201.29 90.28 200.48 89.65 200 88.77C199 86.97 199.62 84.62 201.37 83.53L201.63 83.34C201.97 83.1 202.44 83.18 202.68 83.51C202.92 83.85 202.84 84.32 202.51 84.56L202.2 84.78C201.08 85.48 200.7 86.93 201.31 88.04C201.6 88.56 202.07 88.93 202.63 89.08C203.19 89.23 203.78 89.14 204.29 88.82L206.63 87.37C207.71 86.7 208.09 85.25 207.48 84.13C207.23 83.68 206.83 83.33 206.35 83.15C205.96 83.01 205.76 82.58 205.91 82.19C206.05 81.8 206.49 81.6 206.87 81.75C207.68 82.05 208.36 82.64 208.79 83.41C209.78 85.21 209.17 87.56 207.42 88.65Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.5 101C173.5 107.627 168.127 113 161.5 113C168.127 113 173.5 118.373 173.5 125C173.5 118.373 178.873 113 185.5 113C178.873 113 173.5 107.627 173.5 101Z",
    fill: "#6793FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 126C81.3954 126 80.5 126.895 80.5 128C80.5 129.105 81.3954 130 82.5 130L82.5 126ZM160.914 129.414C161.695 128.633 161.695 127.367 160.914 126.586L148.186 113.858C147.405 113.077 146.139 113.077 145.358 113.858C144.577 114.639 144.577 115.905 145.358 116.686L156.672 128L145.358 139.314C144.577 140.095 144.577 141.361 145.358 142.142C146.139 142.923 147.405 142.923 148.186 142.142L160.914 129.414ZM82.5 130L159.5 130L159.5 126L82.5 126L82.5 130Z",
    fill: "#121212"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 117,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#121212"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroImage);
export default __webpack_public_path__ + "static/media/intro-image.09bd944107a777249e89cf59792d6615.svg";
export { ForwardRef as ReactComponent };